import React, { useState } from 'react';

import BarChartHealthWrapper from '../barChartHealthWrapper/barChartHealthWrapper';
import MapChartHealthWrapper from '../mapChartHealthWrapper/mapChartHealthWrapper';
import LineChartHealthWrapper from '../lineChartHealthWrapper/lineChartHealthWrapper';

import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

// chart data
import Frage_4_Unterste_Einkommen_nominal from 'data/Frage-4_Unterste_Einkommen_nominal.json';
import Frage_4_Unterer_Mittelstand_nominal from 'data/Frage-4_Unterer_Mittelstand_nominal.json';
import Frage_4_Oberer_Mittelstand_nominal from 'data/Frage-4_Oberer_Mittelstand_nominal.json';
import Frage_4_Oberste_Einkommen_nominal from 'data/Frage-4_Oberste_Einkommen_nominal.json';

import Frage_4_Unterste_Einkommen_real from 'data/Frage-4_Unterste_Einkommen_real.json';
import Frage_4_Unterer_Mittelstand_real from 'data/Frage-4_Unterer_Mittelstand_real.json';
import Frage_4_Oberer_Mittelstand_real from 'data/Frage-4_Oberer_Mittelstand_real.json';
import Frage_4_Oberste_Einkommen_real from 'data/Frage-4_Oberste_Einkommen_real.json';

const ChartHealth4Wrapper = () => {
  const questionId = 4;
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const dataFilesNominal = [
    Frage_4_Unterste_Einkommen_nominal,
    Frage_4_Unterer_Mittelstand_nominal,
    Frage_4_Oberer_Mittelstand_nominal,
    Frage_4_Oberste_Einkommen_nominal,
  ];

  const dataFilesReal = [
    Frage_4_Unterste_Einkommen_real,
    Frage_4_Unterer_Mittelstand_real,
    Frage_4_Oberer_Mittelstand_real,
    Frage_4_Oberste_Einkommen_real,
  ];

  return (
    <div>
      <ChartTitleIntro number={questionId} title="Wie sind die Verteilungswirkungen der Kantonsanteile an den stationären Spitalleistungen?">
        <p>
          Hier werden die steuerlichen Umverteilungseffekte der stationären Spitalbehandlungen dargestellt. Rund die Hälfte der Kosten aller
          stationären Spitalleistungen werden von den kantonalen Steuerzahlern finanziert, was zu einer Umverteilung zwischen den Einkommensgruppen
          führt. Ist der Betrag einer Gruppe positiv, dann bezieht sie weniger Leistungen, als sie über die Steuern mitfinanziert. Bei einem negativen
          Betrag nimmt die Gruppe mehr Leistungen in Anspruch, als sie steuerlich mitfinanziert.
        </p>
        <p>
          <em>
            Grafik 4.1 ermöglicht einen Vergleich zwischen den Einkommensgruppen innerhalb eines Kantons. Grafik 4.2 erlaubt einen interkantonalen
            Vergleich der Umverteilungswerte. In Grafik 4.3 ist die Entwicklung der Umverteilung über die Zeit abgebildet (real, zu Preisen des
            jüngsten verfügbaren Jahres). Hier erfahren Sie mehr zu <DataMethodLink />.
          </em>
        </p>
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs uppercase">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => setSelectedTab(0)}>
            {questionId}.1 Vergleich Einkommensgruppen
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => setSelectedTab(1)}>
            {questionId}.2 Interkantonaler Vergleich
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => setSelectedTab(2)}>
            {questionId}.3 Entwicklung über die Zeit
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.1 GRUPPENVERGLEICH UMVERTEILUNG KANTONSANTEILE SPITALLEISTUNGEN</div>
            <BarChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Kantonsanteile Spitalleistungen" />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.2 INTERKANTONALER VERGLEICH UMVERTEILUNG KANTONSANTEILE SPITALLEISTUNGEN</div>
            <MapChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Kantonsanteile Spitalleistungen" />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.3 ENTWICKLUNG UMVERTEILUNG KANTONSANTEILE SPITALLEISTUNGEN</div>
            <LineChartHealthWrapper dataFiles={dataFilesReal} titlePrefix="Umverteilung Kantonsanteile Spitalleistungen" />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default ChartHealth4Wrapper;
